import styled from 'styled-components';

export const StyledHeader = styled.header`
  width: 100%;
  height: 64px;
  flex: 0 0 64px;
  box-sizing: border-box;
  position: relative;
  top: 0;
  background: linear-gradient(152deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 60%, rgba(17, 20, 23, 1) 100%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0 16px;

  //@media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
    overflow-x: hidden;
    overflow-y: hidden;
  //}
`;

export const StyledInfoContainer = styled.div`
  color: #cfd2d4;
  font-size: 1.4em;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 20px 0 10px;
  flex: 0 0 auto;
  min-width: .5rem;
`;

export const StyledLogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: ${(props) => (props.$viewerMode ? '-6px' : '8px')};
  margin-bottom: ${(props) => (props.$viewerMode ? '0' : '-12px')};
  flex: 0 0 auto;
`;
